var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn orcaBtn admin-toggle-btn",class:{ active: _vm.active },attrs:{"disabled":_vm.disabled},on:{"click":_vm.toggleAdmin}},[(!_vm.active)?_c('i',{staticClass:"fas fa-lock"}):_c('i',{staticClass:"fas fa-lock-open"}),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"5px"}},[_vm._v("ADVANCED")])])
}
var staticRenderFns = []

export { render, staticRenderFns }